<template>
  <div>
    <van-nav-bar
      title="扫码入库"
      left-text="返回"
      right-text="扫码记录"
      left-arrow
      @click-left="onClickLeft"
      @click-right="goList"
      fixed
    />
    <van-tabs class="tabs" v-model="selected" type="line" sticky @click="switchTab">
      <van-tab title="启用SN"/>
      <van-tab title="未启用SN"/>
    </van-tabs>
    <div class="psiConfirmCont">
      <div style="display: flex;">
        <van-field
          v-if = "showPosition"
          v-model="position"
          center
          clearable
          autofocus
          ref="positionInput"
          label="货位"
          placeholder="请输入货位条码"
        >
          <template #button>
            <van-button size="small" type="info" @click="validateBinBarcode"
            >确定</van-button
            >
          </template>
        </van-field>
      </div>
      <div v-if="selected === 0" style="display: flex;">
        <van-field
          v-model="value"
          center
          clearable
          label="条码"
          ref="barcodeInput"
          placeholder="请输入条码"
        >
          <template #button>
            <van-button size="small" type="info" @click="confirm"
              >确定</van-button
            >
          </template>
        </van-field>
      </div>
      <div class="psiDetailCont">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            finished-text="没有更多了"
          >
            <div v-for="item in list" class="card" :key="item.uuid">
              <template v-if="selected === 0">
                <table class="layout">
                  <tr>
                    <td><span>商品编码：</span>{{ item.skuCode }}</td>
                  </tr>
                  <tr>
                    <td><span>商品名称：</span>{{ item.skuIdname }}</td>
                  </tr>
                  <tr>
                    <td><span>商品条码：</span>{{ item.barcode }}</td>
                  </tr>
                </table>
              </template>
              <template v-if="selected === 1">
                <table class="layout">
                  <tr>
                    <td><span>商品编码：</span>{{ item.skuCode }}</td>
                    <td rowspan="3">
                      <van-field
                        v-model="item.inputQuantity"
                        center
                        clearable
                        autofocus
                        label=""
                        ref="positionNotCodeInput"
                        placeholder="请输入数量"
                        type="number"
                        @keydown="saveNotCodeQuantity(item.uuid)"
                    >
                    </van-field>
                    </td>
                  </tr>
                  <tr>
                    <td><span>商品名称：</span>{{ item.skuIdname }}</td>
                  </tr>
                  <tr>
                    <td><span>应入库数量：</span>{{ item.quantity }}</td>
                  </tr>
                </table>
              </template>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
      <div class="recordBox">
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <div style="flex: 1;background: #1989fa;display: flex;align-items: center;color:white;height: 30px;padding: 0 10px;border-radius: 2px;font-size: 12px;">
            <span>货位：</span>
            <span style="flex: 1">{{ positionName }}</span>
            <span>已扫码:</span>
            {{ quantity }}
          </div>
          <div style="margin-left:5px;display: flex;">
            <van-button v-if="showStartInput" style="margin-right: 5px;height:30px;font-size: 12px;" type="info" size="large" @click="startInput">开始入库</van-button>
            <van-button v-if="showEndInput" style="height:30px;font-size: 12px;" type="info" size="large" @click="endInput">入库完成</van-button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {NavBar, Field, Button, List, PullRefresh, Toast, Tab, Tabs} from "vant";
import configService from "../../service/configService";
import electronicInputService from "../../service/electronicInputService";
import { formatDictionary } from "../../utils/dictionary";
import moment from "moment";

export default {
  data() {
    return {
      //货位
      selected: 0,
      position: "",
      positionName: "",
      value: "",
      tempPosition: "",
      tempValue: "",
      //货位id
      positionId: "",
      type: "",
      quantity: 0,
      list: [],
      loading: false,
      showStartInput: false,
      showEndInput: false,
      finished: false,
      pageIndex: 0,
      refreshing: false,
      fields:[],
      dictNames: "",
      showPosition: true
    };
  },
  mounted: async function() {
    let resp = await configService.getConfigByName("扫码入库显示货位输入框");
    if (resp.data.Status === "1"){
      if (resp.data.Data && resp.data.Data.value === "否"){
        this.showPosition = false;
      }
    }

    if(this.showPosition){
      this.$refs.positionInput.focus();
    }else{
      this.$refs.barcodeInput.focus();
    }

    this.type = this.$route.query.type;
    let that = this;
    document.onkeydown = function(event) {
      if (event.keyCode == 13) {
        that.tempPosition = that.position;
        that.tempValue = that.value;
        if(that.tempPosition.length > 0){
          if(that.tempPosition.indexOf("HW") < 0 && that.positionId.indexOf("HW") < 0){
            that.value = that.tempValue;
            this.position = "";
          }
        }
        if(that.tempValue.length > 0){
          if(that.tempValue.indexOf("HW") > -1){
            that.position = that.tempPosition;
            that.value = "";
          }
        }
        if ((that.position.length > 0 && that.value.length == 0)
              || (!that.showPosition && that.value.length == 0)) {
          that.$refs.barcodeInput.focus();
        } else {
          that.confirm();
        }
      }
    };
  },
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.push({path:"/electronicErp/scanHistory/" + this.$route.params.inputDataId})
    },
    async confirm() {
      if (this.showStartInput){
        Toast.fail("还没开始入库");
        return;
      }
      if (!this.showEndInput){
        Toast.fail("已经入库完成");
        return;
      }
      if (this.positionName == ""){
        Toast.fail("请先输入货位码");
        return;
      }
      if (this.value == ""){
        Toast.fail("条码不能为空");
        return;
      }
      let resp = await electronicInputService.inputForMobile(this.$route.params.inputDataId, this.value, this.position);
      if (resp.data.Status === "1") {
        Toast.success("扫码入库成功");
        this.onRefresh();
        this.value = "";
        this.$refs.barcodeInput.focus();
      } else {
        Toast.fail(resp.data.Message);
        this.value = "";
        this.$refs.barcodeInput.focus();
      }
    },
    async saveNotCodeQuantity(detailId) {
      if (this.showStartInput){
        Toast.fail("还没开始入库");
        this.onRefresh();
        return;
      }
      if (!this.showEndInput){
        Toast.fail("已经入库完成");
        this.onRefresh();
        return;
      }
      if (this.positionName === ""){
        Toast.fail("请先输入货位码");
        this.onRefresh();
        return;
      }

      if (event.keyCode === 13) {
        // 修改为数量
        if (event.target.value === "" || event.target.value === "0") {
          Toast.fail("数量不能为空");
          this.onRefresh();
          return;
        }
        let resp = await electronicInputService.saveNotCodeQuantity(detailId, event.target.value, this.position);
        if (resp.data.Status === "1") {
          Toast.success("入库成功");
          this.onRefresh();
        } else {
          Toast.fail(resp.data.Message);
          this.onRefresh();
        }
      }
    },
    async validateBinBarcode() {
      if (this.showStartInput){
        Toast.fail("还没开始入库");
        return;
      }
      if (!this.showEndInput){
        Toast.fail("已经入库完成");
        return;
      }
      let resp = await electronicInputService.validateBinBarcode(this.position);
      if (resp.data.Status === "1") {
        this.positionId = resp.data.Data[0].uuid;
        this.positionName = resp.data.Data[0].name;
        this.value = "";
        if (this.selected === 0){
          this.$refs.barcodeInput.focus();
        }
      } else {
        Toast.fail(resp.data.Message);
        this.position = "";
        this.$refs.positionInput.focus();
      }
    },
    async onLoad() {
      this.pageIndex++;
      let resp = await electronicInputService.getInputDetailForMobile(
          this.pageIndex,
          this.$route.params.inputDataId,
          this.selected,
          "notInput"
      );
      if (resp.data.Status == '1' && resp.data.Data.data.length > 0) {
        resp.data.Data.data.forEach(item => {
          item.inputTime = moment(item.inputTime).format("YYYY-MM-DD");
        });
      }
      formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      let resp1 = await electronicInputService.getInputDetailQuantityForMobile(this.$route.params.inputDataId);
      this.quantity = resp1.data.Data;
      let resp2 = await electronicInputService.getInputOrderStatus(this.$route.params.inputDataId);
      if (resp2.data.Data == '1'){
        this.showStartInput = false;
        this.showEndInput = true;
      }else if (resp2.data.Data == '2'){
        this.showStartInput = false;
        this.showEndInput = false;
      }else {
        this.showStartInput = true;
        this.showEndInput = true;
      }
      this.loading = false;
      this.refreshing = false;
      this.list = [...this.list, ...resp.data.Data.data];
      this.finished = resp.data.Data.total <= this.list.length;
    },
    async startInput() {
      let resp = await electronicInputService.updateStatusByOrderId(this.$route.params.inputDataId, "1");
      if (resp.data.Status == '1'){
        Toast.success("开始入库");
        this.showStartInput = false;
        this.showEndInput = true;
      }
    },
    async endInput() {
      let resp = await electronicInputService.updateStatusByOrderId(this.$route.params.inputDataId, "2");
      if (resp.data.Status == '1'){
        Toast.success("入库完成");
      }else {
        this.showStartInput = true;
        this.showEndInput = true;
      }
    },
    switchTab(tabIndex) {
      localStorage.setItem('inputDataTabIndex', tabIndex);
      window.scrollTo(0, 0);
      this.type = tabIndex;
      this.value = '';
      this.onRefresh();
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    }
  },
};
</script>

<style scoped>
.psiConfirmCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 120px;
  overflow: hidden;
}
.btnBox {
}
.recordBox {
  padding: 0.5rem 0;
  box-sizing: border-box;
  margin-top: 2rem;
  bottom: 0;
  position: fixed;
  width: 100%;
}
.psiDetailCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
}
</style>
